import React, { Component } from 'react';
import { Col, Layout, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { connect } from 'react-redux';

import { queryOrderList } from '@api/xxcrm/order';
import util from '@util';
import ModalStep from './ModalStep';
import ModalService from './ModalService';

import SearchForm from './FormSearch';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
      pageNo: 1,
      total: 0,
      stepVisible: false,
      serviceVisible: false,
    };
  }

  componentWillMount() {
    this.cdate = '';
    this.condition = '';
    this.orgUuid = '';
    this.userUuid = '';
  }

  componentDidMount() {
    this.loadDate(1, 15);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  /**
   * 获取订单列表
   */
  loadDate = pageNo => {
    this.setState({
      isLoading: true,
    });
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = this.condition || '';
    // params.cdate = this.cdate ? moment(this.cdate).format('YYYY-MM-DD') : ""
    params.cdate = this.cdate || '';
    params.orgUuid = this.orgUuid || '';
    params.userUuid = this.userUuid || '';
    if (!params.cdate) {
      delete params.cdate;
    }
    this.setState({
      pageNo: current,
    });
    queryOrderList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      }
    });
  };

  search = condition => {
    this.condition = condition.condition ? condition.condition : '';
    this.cdate = condition.cdate;
    this.orgUuid = condition.orgUuid;
    this.userUuid = condition.userUuid;
    this.loadDate(1, 15);
  };

  showStep = () => {
    this.setState({
      stepVisible: true,
    });
  };

  showService = () => {
    this.setState({
      serviceVisible: true,
    });
  };

  cancel = () => {
    this.setState({
      stepVisible: false,
      serviceVisible: false,
    });
  };

  columns = () => {
    return [
      {
        title: '订单编号',
        dataIndex: 'orderNo',
        key: 'orderNo',
        width: 150,
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 150,
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '合同号',
        dataIndex: 'contractNo',
        key: 'contractNo',
        width: 180,
      },
      {
        title: '客户名',
        dataIndex: 'orderName',
        key: 'orderName',
        width: 350,
        render: (text, record) => {
          return (
            <span>
              {text}({record.orderWay})
            </span>
          );
        },
      },
      {
        title: '合同金额',
        dataIndex: 'contractPrice',
        key: 'contractPrice',
        width: 150,
      },
      {
        title: '所属人',
        dataIndex: 'createUserName',
        key: 'createUserName',
        width: 150,
      },
      {
        title: '发票',
        dataIndex: 'isInvoice',
        key: 'isInvoice',
        width: 150,
        render: text => {
          return <span>{text === 0 ? '未开票' : '已开票'}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: 150,
        render: text => {
          return <span>{text === 0 ? '未完成' : '已完成'}</span>;
        },
      },
      {
        title: '提交审核',
        dataIndex: 'isReview',
        key: 'isReview',
        width: 150,
        render: text => {
          return <span>{text === 0 ? '未提单' : '已提单'}</span>;
        },
      },
      {
        title: '操作',
        key: 'done',
        width: 200,
        render: (rext, record) => (
          <span>
            <Link to={`/xianxing/order/${record.uuid}/detail`}>详情</Link>
            {/* <span>丨<a onClick={this.showStep}>步骤</a></span> */}
            {/* <span>丨<a onClick={this.showService}>客服</a></span> */}
          </span>
        ),
      },
    ];
  };

  render() {
    const { data, total, isLoading } = this.state;
    const pagination = {
      total,
      showSizeChanger: false,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const tH = util.pageHeight() - 218;
    const { stepVisible, serviceVisible } = this.state;
    return (
      <Layout>
        <div className="fixed-header">
          <Row justify="space-between" type="flex" style={{ marginBottom: '16px' }}>
            <Col span={24}>
              <SearchForm search={this.search} />
            </Col>
          </Row>
        </div>
        <div>
          <Table
            rowKey="orderNo"
            rowSelection={{}}
            columns={this.columns()}
            loading={isLoading}
            dataSource={data}
            pagination={pagination}
            style={{ paddingTop: '70px' }}
            scroll={{ x: 1300, y: tH }}
          />
          {stepVisible ? <ModalStep cancel={this.cancel} /> : ''}
          {serviceVisible ? <ModalService cancel={this.cancel} /> : ''}
        </div>
      </Layout>
    );
  }
}
export default connect(state => ({
  list: state.contract_type,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/order/Index.js